import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Home from "./components/Home";
import BojagicardPage from "./components/BojagicardPage";
import KakaoSharePage from "./components/KakaoSharePage";
import Dashboard from "./admin/Dashboard";
import Login from "./admin/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import FloatingHearts from "./components/FloatingHearts";

import Emails from "./admin/Emails";
import { AuthProvider } from "./contexts/AuthContext";
import "./App.css";
import AdminLayout from "./admin/AdminLayout";
import WeddingInfo from "./admin/WeddingInfo";
import GuestbookManagement from "./admin/GuestbookManagement";
import MessageManagement from "./admin/MessageManagement";
import GalleryManagement from "./admin/GalleryManagement";
import PageSettings from "./admin/PageSettings";

const AppContent: React.FC = () => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");
  const isAddEmailPage = location.pathname === "/add-email";

  useEffect(() => {
    // admin 페이지나 이메일 추가 페이지에서는 이벤트 제한을 적용하지 않음
    if (isAdminPage || isAddEmailPage) {
      return;
    }

    // 우클릭 방지
    const preventRightClick = (e: MouseEvent) => {
      e.preventDefault();
    };

    // 드래그 방지
    const preventDrag = (e: DragEvent) => {
      e.preventDefault();
    };

    // 선택 방지
    const preventSelect = (e: Event) => {
      e.preventDefault();
    };

    // 키보드 단축키 방지
    const preventKeyShortcuts = (e: KeyboardEvent) => {
      if (
        (e.ctrlKey &&
          (e.key === "c" ||
            e.key === "C" ||
            e.key === "v" ||
            e.key === "V" ||
            e.key === "u" ||
            e.key === "U")) ||
        e.key === "F12" ||
        (e.altKey && (e.key === "F4" || e.key === "F5"))
      ) {
        e.preventDefault();
      }
    };

    // CSS 스타일 추가
    const style = document.createElement("style");
    style.textContent = `
      * {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
        -webkit-user-drag: none !important;
        -moz-user-drag: none !important;
        -ms-user-drag: none !important;
        user-drag: none !important;
      }
    `;
    document.head.appendChild(style);

    // 이벤트 리스너 등록
    document.addEventListener("contextmenu", preventRightClick);
    document.addEventListener("dragstart", preventDrag);
    document.addEventListener("selectstart", preventSelect);
    document.addEventListener("mousedown", preventSelect);
    document.addEventListener("keydown", preventKeyShortcuts);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      document.removeEventListener("contextmenu", preventRightClick);
      document.removeEventListener("dragstart", preventDrag);
      document.removeEventListener("selectstart", preventSelect);
      document.removeEventListener("mousedown", preventSelect);
      document.removeEventListener("keydown", preventKeyShortcuts);
      document.head.removeChild(style);
    };
  }, [isAdminPage, isAddEmailPage]);

  return (
    <div className="app">
      {!isAdminPage && !isAddEmailPage && location.pathname !== "/" && <FloatingHearts />}
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<BojagicardPage />} />
        <Route path="/old" element={<Home />} />
        <Route path="/kakao" element={<KakaoSharePage />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="wedding-info" element={<WeddingInfo />} />
            <Route path="messages" element={<MessageManagement />} />
            <Route path="gallery" element={<GalleryManagement />} />
            <Route path="page-settings" element={<PageSettings />} />
            <Route path="emails" element={<Emails />} />
            <Route path="guestbook" element={<GuestbookManagement />} />
            {/* Admin catch-all: redirect unknown admin paths to dashboard */}
            <Route
              path="*"
              element={<Navigate to="/admin/dashboard" replace />}
            />
          </Route>
        </Route>
        {/* Catch all route - redirect to home */}
        <Route path="*" element={<BojagicardPage />} />
      </Routes>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
